export default {
  data () {
    return {
      countries: [
        {
          name: 'United States',
          code: 'US',
          currencyCode: 'USD'
        },
        {
          name: 'United Kingdom',
          code: 'GB',
          currencyCode: 'GBP'
        },
        {
          name: 'Canada',
          code: 'CA',
          currencyCode: 'CAD'
        },
        {
          name: 'Australia',
          code: 'AU',
          currencyCode: 'AUD'
        },
        {
          name: 'New Zealand',
          code: 'NZ',
          currencyCode: 'NZD'
        },
        {
          name: 'South Africa',
          code: 'ZA',
          currencyCode: 'ZAR'
        },
        {
          name: 'Italy',
          code: 'IT',
          currencyCode: 'EUR'
        },
        {
          name: 'Netherlands',
          code: 'NL',
          currencyCode: 'EUR'
        },
        {
          name: 'France',
          code: 'FR',
          currencyCode: 'EUR'
        },
        {
          name: 'Spain',
          code: 'ES',
          currencyCode: 'EUR'
        },
        {
          name: 'Belgium',
          code: 'BE',
          currencyCode: 'EUR'
        },
        {
          name: 'Germany',
          code: 'DE',
          currencyCode: 'EUR'
        },
        {
          name: 'Switzerland',
          code: 'CH',
          currencyCode: 'CHF'
        },
        {
          name: 'Austria',
          code: 'AT',
          currencyCode: 'EUR'
        },
        {
          name: 'Poland',
          code: 'PL',
          currencyCode: 'PLN'
        },
        {
          name: 'Brazil',
          code: 'BR',
          currencyCode: 'BRL'
        },
        {
          name: 'Mexico',
          code: 'MX',
          currencyCode: 'MXN'
        },
        {
          name: 'India',
          code: 'IN',
          currencyCode: 'INR'
        },
        {
          name: 'Albania',
          code: 'AL',
          currencyCode: 'ALL'
        },
        {
          name: 'Algeria',
          code: 'DZ',
          currencyCode: 'DZD'
        },
        {
          name: 'Andorra',
          code: 'AD',
          currencyCode: 'EUR'
        },
        {
          name: 'Angola',
          code: 'AO',
          currencyCode: 'AOA'
        },
        {
          name: 'Argentina',
          code: 'AR',
          currencyCode: 'ARS'
        },
        {
          name: 'Armenia',
          code: 'AM',
          currencyCode: 'AMD'
        },
        {
          name: 'Azerbaijan',
          code: 'AZ',
          currencyCode: 'AZN'
        },
        {
          name: 'Bahamas',
          code: 'BS',
          currencyCode: 'BSD'
        },
        {
          name: 'Bahrain',
          code: 'BH',
          currencyCode: 'BHD'
        },
        {
          name: 'Bangladesh',
          code: 'BD',
          currencyCode: 'BDT'
        },
        {
          name: 'Barbados',
          code: 'BB',
          currencyCode: 'BBD'
        },
        {
          name: 'Belarus',
          code: 'BY',
          currencyCode: 'BYN'
        },
        {
          name: 'Benin',
          code: 'BJ',
          currencyCode: 'XOF'
        },
        {
          name: 'Bermuda',
          code: 'BM',
          currencyCode: 'BMD'
        },
        {
          name: 'Bolivia',
          code: 'BO',
          currencyCode: 'BOB'
        },
        {
          name: 'Bosnia and Herzegovina',
          code: 'BA',
          currencyCode: 'BAM'
        },
        {
          name: 'Botswana',
          code: 'BW',
          currencyCode: 'BWP'
        },
        {
          name: 'Brunei',
          code: 'BN',
          currencyCode: 'BND'
        },
        {
          name: 'Bulgaria',
          code: 'BG',
          currencyCode: 'BGN'
        },
        {
          name: 'Burkina Faso',
          code: 'BF',
          currencyCode: 'XOF'
        },
        {
          name: 'Burundi',
          code: 'BI',
          currencyCode: 'BIF'
        },
        {
          name: 'Cambodia',
          code: 'KH',
          currencyCode: 'KHR'
        },
        {
          name: 'Cameroon',
          code: 'CM',
          currencyCode: 'XAF'
        },
        {
          name: 'Cape Verde',
          code: 'CV',
          currencyCode: 'CVE'
        },
        {
          name: 'Cayman Islands',
          code: 'KY',
          currencyCode: 'KYD'
        },
        {
          name: 'Central African Republic',
          code: 'CF',
          currencyCode: 'XAF'
        },
        {
          name: 'Chad',
          code: 'TD',
          currencyCode: 'XAF'
        },
        {
          name: 'Chile',
          code: 'CL',
          currencyCode: 'CLP'
        },
        {
          name: 'China',
          code: 'CN',
          currencyCode: 'CNY'
        },
        {
          name: 'Colombia',
          code: 'CO',
          currencyCode: 'COP'
        },
        {
          name: 'Congo Republic',
          code: 'CG',
          currencyCode: 'XAF'
        },
        {
          name: 'DR Congo',
          code: 'CD',
          currencyCode: 'CDF'
        },
        {
          name: 'Cook Islands',
          code: 'CK',
          currencyCode: 'NZD'
        },
        {
          name: 'Costa Rica',
          code: 'CR',
          currencyCode: 'CRC'
        },
        {
          name: 'Côte d’Ivoire',
          code: 'CI',
          currencyCode: 'XOF'
        },
        {
          name: 'Croatia',
          code: 'HR',
          currencyCode: 'HRK'
        },
        {
          name: 'Cuba',
          code: 'CU',
          currencyCode: 'CUP'
        },
        {
          name: 'Cyprus',
          code: 'CY',
          currencyCode: 'EUR'
        },
        {
          name: 'Czech Republic',
          code: 'CZ',
          currencyCode: 'CZK'
        },
        {
          name: 'Denmark',
          code: 'DK',
          currencyCode: 'DKK'
        },
        {
          name: 'Djibouti',
          code: 'DJ',
          currencyCode: 'DJF'
        },
        {
          name: 'Dominica',
          code: 'DM',
          currencyCode: 'XCD'
        },
        {
          name: 'Dominican Republic',
          code: 'DO',
          currencyCode: 'DOP'
        },
        {
          name: 'Ecuador',
          code: 'EC',
          currencyCode: 'USD'
        },
        {
          name: 'Egypt',
          code: 'EG',
          currencyCode: 'EGP'
        },
        {
          name: 'El Salvador',
          code: 'SV',
          currencyCode: 'USD'
        },
        {
          name: 'Equatorial Guinea',
          code: 'GQ',
          currencyCode: 'XAF'
        },
        {
          name: 'Eritrea',
          code: 'ER',
          currencyCode: 'ERN'
        },
        {
          name: 'Estonia',
          code: 'EE',
          currencyCode: 'EUR'
        },
        {
          name: 'Eswatini',
          code: 'SZ',
          currencyCode: 'SZL'
        },
        {
          name: 'Ethiopia',
          code: 'ET',
          currencyCode: 'ETB'
        },
        {
          name: 'Faroe Islands',
          code: 'FO',
          currencyCode: 'DKK'
        },
        {
          name: 'Fiji',
          code: 'FJ',
          currencyCode: 'FJD'
        },
        {
          name: 'Finland',
          code: 'FI',
          currencyCode: 'EUR'
        },
        {
          name: 'French Guiana',
          code: 'GF',
          currencyCode: 'EUR'
        },
        {
          name: 'French Polynesia',
          code: 'PF',
          currencyCode: 'XPF'
        },
        {
          name: 'Gabon',
          code: 'GA',
          currencyCode: 'XAF'
        },
        {
          name: 'Georgia',
          code: 'GE',
          currencyCode: 'GEL'
        },
        {
          name: 'Ghana',
          code: 'GH',
          currencyCode: 'GHS'
        },
        {
          name: 'Gibraltar',
          code: 'GI',
          currencyCode: 'GIP'
        },
        {
          name: 'Greece',
          code: 'GR',
          currencyCode: 'EUR'
        },
        {
          name: 'Guadeloupe',
          code: 'GP',
          currencyCode: 'EUR'
        },
        {
          name: 'Guam',
          code: 'GU',
          currencyCode: 'USD'
        },
        {
          name: 'Guatemala',
          code: 'GT',
          currencyCode: 'GTQ'
        },
        {
          name: 'Guinea',
          code: 'GN',
          currencyCode: 'GNF'
        },
        {
          name: 'Guyana',
          code: 'GY',
          currencyCode: 'GYD'
        },
        {
          name: 'Haiti',
          code: 'HT',
          currencyCode: 'HTG'
        },
        {
          name: 'Honduras',
          code: 'HN',
          currencyCode: 'HNL'
        },
        {
          name: 'Hong Kong',
          code: 'HK',
          currencyCode: 'HKD'
        },
        {
          name: 'Hungary',
          code: 'HU',
          currencyCode: 'HUF'
        },
        {
          name: 'Iceland',
          code: 'IS',
          currencyCode: 'ISK'
        },
        {
          name: 'Indonesia',
          code: 'ID',
          currencyCode: 'IDR'
        },
        {
          name: 'Iran',
          code: 'IR',
          currencyCode: 'IRR'
        },
        {
          name: 'Iraq',
          code: 'IQ',
          currencyCode: 'IQD'
        },
        {
          name: 'Ireland',
          code: 'IE',
          currencyCode: 'EUR'
        },
        {
          name: 'Isle of Man',
          code: 'IM',
          currencyCode: 'GBP'
        },
        {
          name: 'Israel',
          code: 'IL',
          currencyCode: 'ILS'
        },
        {
          name: 'Jamaica',
          code: 'JM',
          currencyCode: 'JMD'
        },
        {
          name: 'Japan',
          code: 'JP',
          currencyCode: 'JPY'
        },
        {
          name: 'Jordan',
          code: 'JO',
          currencyCode: 'JOD'
        },
        {
          name: 'Kazakhstan',
          code: 'KZ',
          currencyCode: 'KZT'
        },
        {
          name: 'Kenya',
          code: 'KE',
          currencyCode: 'KES'
        },
        {
          name: 'North Korea',
          code: 'KP',
          currencyCode: 'KPW'
        },
        {
          name: 'South Korea',
          code: 'KR',
          currencyCode: 'KRW'
        },
        {
          name: 'Kuwait',
          code: 'KW',
          currencyCode: 'KWD'
        },
        {
          name: 'Kyrgyzstan',
          code: 'KG',
          currencyCode: 'KGS'
        },
        {
          name: 'Latvia',
          code: 'LV',
          currencyCode: 'EUR'
        },
        {
          name: 'Lebanon',
          code: 'LB',
          currencyCode: 'LBP'
        },
        {
          name: 'Lesotho',
          code: 'LS',
          currencyCode: 'LSL'
        },
        {
          name: 'Liberia',
          code: 'LR',
          currencyCode: 'LRD'
        },
        {
          name: 'Libya',
          code: 'LY',
          currencyCode: 'LYD'
        },
        {
          name: 'Liechtenstein',
          code: 'LI',
          currencyCode: 'CHF'
        },
        {
          name: 'Lithuania',
          code: 'LT',
          currencyCode: 'EUR'
        },
        {
          name: 'Luxembourg',
          code: 'LU',
          currencyCode: 'EUR'
        },
        {
          name: 'Macao',
          code: 'MO',
          currencyCode: 'MOP'
        },
        {
          name: 'Madagascar',
          code: 'MG',
          currencyCode: 'MGA'
        },
        {
          name: 'Malawi',
          code: 'MW',
          currencyCode: 'MWK'
        },
        {
          name: 'Malaysia',
          code: 'MY',
          currencyCode: 'MYR'
        },
        {
          name: 'Maldives',
          code: 'MV',
          currencyCode: 'MVR'
        },
        {
          name: 'Mali',
          code: 'ML',
          currencyCode: 'XOF'
        },
        {
          name: 'Malta',
          code: 'MT',
          currencyCode: 'EUR'
        },
        {
          name: 'Martinique',
          code: 'MQ',
          currencyCode: 'EUR'
        },
        {
          name: 'Mauritania',
          code: 'MR',
          currencyCode: 'MRU'
        },
        {
          name: 'Mauritius',
          code: 'MU',
          currencyCode: 'MUR'
        },
        {
          name: 'Moldova',
          code: 'MD',
          currencyCode: 'MDL'
        },
        {
          name: 'Monaco',
          code: 'MC',
          currencyCode: 'EUR'
        },
        {
          name: 'Mongolia',
          code: 'MN',
          currencyCode: 'MNT'
        },
        {
          name: 'Montenegro',
          code: 'ME',
          currencyCode: 'EUR'
        },
        {
          name: 'Morocco',
          code: 'MA',
          currencyCode: 'MAD'
        },
        {
          name: 'Mozambique',
          code: 'MZ',
          currencyCode: 'MZN'
        },
        {
          name: 'Myanmar',
          code: 'MM',
          currencyCode: 'MMK'
        },
        {
          name: 'Namibia',
          code: 'NA',
          currencyCode: 'NAD'
        },
        {
          name: 'Nauru',
          code: 'NR',
          currencyCode: 'AUD'
        },
        {
          name: 'Nepal',
          code: 'NP',
          currencyCode: 'NPR'
        },
        {
          name: 'Nicaragua',
          code: 'NI',
          currencyCode: 'NIO'
        },
        {
          name: 'Niger',
          code: 'NE',
          currencyCode: 'XOF'
        },
        {
          name: 'Nigeria',
          code: 'NG',
          currencyCode: 'NGN'
        },
        {
          name: 'North Macedonia',
          code: 'MK',
          currencyCode: 'MKD'
        },
        {
          name: 'Norway',
          code: 'NO',
          currencyCode: 'NOK'
        },
        {
          name: 'Oman',
          code: 'OM',
          currencyCode: 'OMR'
        },
        {
          name: 'Pakistan',
          code: 'PK',
          currencyCode: 'PKR'
        },
        {
          name: 'Palau',
          code: 'PW',
          currencyCode: 'USD'
        },
        {
          name: 'Palestine',
          code: 'PS',
          currencyCode: 'ILS'
        },
        {
          name: 'Panama',
          code: 'PA',
          currencyCode: 'PAB'
        },
        {
          name: 'Papua New Guinea',
          code: 'PG',
          currencyCode: 'PGK'
        },
        {
          name: 'Paraguay',
          code: 'PY',
          currencyCode: 'PYG'
        },
        {
          name: 'Peru',
          code: 'PE',
          currencyCode: 'PEN'
        },
        {
          name: 'Philippines',
          code: 'PH',
          currencyCode: 'PHP'
        },
        {
          name: 'Portugal',
          code: 'PT',
          currencyCode: 'EUR'
        },
        {
          name: 'Puerto Rico',
          code: 'PR',
          currencyCode: 'USD'
        },
        {
          name: 'Qatar',
          code: 'QA',
          currencyCode: 'QAR'
        },
        {
          name: 'Reunion',
          code: 'RE',
          currencyCode: 'EUR'
        },
        {
          name: 'Romania',
          code: 'RO',
          currencyCode: 'RON'
        },
        {
          name: 'Russian Federation',
          code: 'RU',
          currencyCode: 'RUB'
        },
        {
          name: 'Rwanda',
          code: 'RW',
          currencyCode: 'RWF'
        },
        {
          name: 'Saint Lucia',
          code: 'LC',
          currencyCode: 'XCD'
        },
        {
          name: 'Saint Martin',
          code: 'MF',
          currencyCode: 'EUR'
        },
        {
          name: 'Samoa',
          code: 'WS',
          currencyCode: 'WST'
        },
        {
          name: 'San Marino',
          code: 'SM',
          currencyCode: 'EUR'
        },
        {
          name: 'Sao Tome and Principe',
          code: 'ST',
          currencyCode: 'STN'
        },
        {
          name: 'Saudi Arabia',
          code: 'SA',
          currencyCode: 'SAR'
        },
        {
          name: 'Senegal',
          code: 'SN',
          currencyCode: 'XOF'
        },
        {
          name: 'Serbia',
          code: 'RS',
          currencyCode: 'RSD'
        },
        {
          name: 'Seychelles',
          code: 'SC',
          currencyCode: 'SCR'
        },
        {
          name: 'Sierra Leone',
          code: 'SL',
          currencyCode: 'SLL'
        },
        {
          name: 'Singapore',
          code: 'SG',
          currencyCode: 'SGD'
        },
        {
          name: 'Slovakia',
          code: 'SK',
          currencyCode: 'EUR'
        },
        {
          name: 'Slovenia',
          code: 'SI',
          currencyCode: 'EUR'
        },
        {
          name: 'Solomon Islands',
          code: 'SB',
          currencyCode: 'SBD'
        },
        {
          name: 'Somalia',
          code: 'SO',
          currencyCode: 'SOS'
        },
        {
          name: 'South Sudan',
          code: 'SS',
          currencyCode: 'SSP'
        },
        {
          name: 'Sri Lanka',
          code: 'LK',
          currencyCode: 'LKR'
        },
        {
          name: 'Sudan',
          code: 'SD',
          currencyCode: 'SDG'
        },
        {
          name: 'Suriname',
          code: 'SR',
          currencyCode: 'SRD'
        },
        {
          name: 'Sweden',
          code: 'SE',
          currencyCode: 'SEK'
        },
        {
          name: 'Syrian Arab Republic',
          code: 'SY',
          currencyCode: 'SYP'
        },
        {
          name: 'Taiwan',
          code: 'TW',
          currencyCode: 'TWD'
        },
        {
          name: 'Tajikistan',
          code: 'TJ',
          currencyCode: 'TJS'
        },
        {
          name: 'Tanzania',
          code: 'TZ',
          currencyCode: 'TZS'
        },
        {
          name: 'Thailand',
          code: 'TH',
          currencyCode: 'THB'
        },
        {
          name: 'Togo',
          code: 'TG',
          currencyCode: 'XOF'
        },
        {
          name: 'Tonga',
          code: 'TO',
          currencyCode: 'TOP'
        },
        {
          name: 'Trinidad and Tobago',
          code: 'TT',
          currencyCode: 'TTD'
        },
        {
          name: 'Tunisia',
          code: 'TN',
          currencyCode: 'TND'
        },
        {
          name: 'Turkey',
          code: 'TR',
          currencyCode: 'TRY'
        },
        {
          name: 'Turkmenistan',
          code: 'TM',
          currencyCode: 'TMT'
        },
        {
          name: 'Uganda',
          code: 'UG',
          currencyCode: 'UGX'
        },
        {
          name: 'Ukraine',
          code: 'UA',
          currencyCode: 'UAH'
        },
        {
          name: 'United Arab Emirates',
          code: 'AE',
          currencyCode: 'AED'
        },
        {
          name: 'Uruguay',
          code: 'UY',
          currencyCode: 'UYU'
        },
        {
          name: 'Uzbekistan',
          code: 'UZ',
          currencyCode: 'UZS'
        },
        {
          name: 'Venezuela',
          code: 'VE',
          currencyCode: 'VES'
        },
        {
          name: 'Vietnam',
          code: 'VN',
          currencyCode: 'VND'
        },
        {
          name: 'Yemen',
          code: 'YE',
          currencyCode: 'YER'
        },
        {
          name: 'Zambia',
          code: 'ZM',
          currencyCode: 'ZMW'
        },
        {
          name: 'Zimbabwe',
          code: 'ZW',
          currencyCode: 'ZWL'
        }
      ]
    }
  },

  methods: {
    getCountryNameByCode (countryCode) {
      return this.countries.find(country => country.code === countryCode).name
    }
  }
}
